module.exports = __webpack_public_path__ + "static/media/tvshows-selected.af4a950a.svg";